/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: vzgTyjXsvFqD

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { FormProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormProvider"; // plasmic-import: R4jbURjT8nMH/codeComponent
import MultiFactorAuthModal from "../../MultiFactorAuthModal"; // plasmic-import: t5CKmWfTpe_O/component
import { FormControlProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormControlProvider"; // plasmic-import: v9MLUrEpQF_1/codeComponent
import TextInput from "../../TextInput"; // plasmic-import: kx7Qgd3B-3Xa/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import SpinnerIcon from "../../SpinnerIcon"; // plasmic-import: 0R7aXYvaG7Fy/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeLoginSection.module.css"; // plasmic-import: vzgTyjXsvFqD/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

import { zod as __fn_zod } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/zod"; // plasmic-import: zod/customFunction

createPlasmicElementProxy;

export type PlasmicHomeLoginSection__VariantMembers = {};
export type PlasmicHomeLoginSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeLoginSection__VariantsArgs;
export const PlasmicHomeLoginSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeLoginSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeLoginSection__ArgsType;
export const PlasmicHomeLoginSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeLoginSection__OverridesType = {
  loginSection?: Flex__<"section">;
  login?: Flex__<"div">;
  warning?: Flex__<"div">;
  wrapper?: Flex__<"div">;
  icon?: Flex__<"div">;
  wrapper2?: Flex__<"div">;
  img?: Flex__<typeof PlasmicImg__>;
  text?: Flex__<"div">;
  wrapper4?: Flex__<"div">;
  wrapper3?: Flex__<"div">;
  title?: Flex__<"label">;
  loginForm?: Flex__<typeof FormProvider>;
  multiFactorAuthModal?: Flex__<typeof MultiFactorAuthModal>;
  form?: Flex__<"form">;
  usernameProvider?: Flex__<typeof FormControlProvider>;
  usernameInput?: Flex__<typeof TextInput>;
  passwordProvider?: Flex__<typeof FormControlProvider>;
  passwordInput?: Flex__<typeof TextInput>;
  logInButton?: Flex__<typeof Button>;
  spinnerIcon?: Flex__<typeof SpinnerIcon>;
  link?: Flex__<"a"> & Partial<LinkProps>;
};

export interface DefaultHomeLoginSectionProps {
  className?: string;
}

const $$ = {
  zod: __fn_zod
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeLoginSection__RenderFunc(props: {
  variants: PlasmicHomeLoginSection__VariantsArgs;
  args: PlasmicHomeLoginSection__ArgsType;
  overrides: PlasmicHomeLoginSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "usernameInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.usernameProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "passwordInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.passwordProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "isFormSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.factors",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => []
      },
      {
        path: "multiFactorAuthModal.isChallengeSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.methodSelected",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.cooldown",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ({
          Email: 0,
          SMS: 0,
          Password: 0
        })
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"loginSection"}
      data-plasmic-override={overrides.loginSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.loginSection
      )}
    >
      <div
        data-plasmic-name={"login"}
        data-plasmic-override={overrides.login}
        className={classNames(projectcss.all, sty.login)}
      >
        {false ? (
          <div
            data-plasmic-name={"warning"}
            data-plasmic-override={overrides.warning}
            className={classNames(projectcss.all, sty.warning)}
          >
            <div
              data-plasmic-name={"wrapper"}
              data-plasmic-override={overrides.wrapper}
              className={classNames(projectcss.all, sty.wrapper)}
            >
              <div
                data-plasmic-name={"icon"}
                data-plasmic-override={overrides.icon}
                className={classNames(projectcss.all, sty.icon)}
              >
                <div
                  data-plasmic-name={"wrapper2"}
                  data-plasmic-override={overrides.wrapper2}
                  className={classNames(projectcss.all, sty.wrapper2)}
                >
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"16px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"16px"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/ebdc2b86fd34b82749fde541e0aef1a2.svg",
                      fullWidth: 16,
                      fullHeight: 16,
                      aspectRatio: 1
                    }}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {
                  "Scheduled maintenance at 5:00 pm EST lasting up to 15 min. Sorry for the inconvenience."
                }
              </div>
            </div>
          </div>
        ) : null}
        <div
          data-plasmic-name={"wrapper4"}
          data-plasmic-override={overrides.wrapper4}
          className={classNames(projectcss.all, sty.wrapper4)}
        >
          <div
            data-plasmic-name={"wrapper3"}
            data-plasmic-override={overrides.wrapper3}
            className={classNames(projectcss.all, sty.wrapper3)}
          >
            <label
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Member Login"}
            </label>
            <FormProvider
              data-plasmic-name={"loginForm"}
              data-plasmic-override={overrides.loginForm}
              className={classNames("__wab_instance", sty.loginForm)}
              contextName={"loginForm"}
              mode={"all"}
              reValidateMode={"onChange"}
              zodValidationSchema={(() => {
                try {
                  return (() => {
                    const z = $$.zod();
                    const schema = z.object({
                      username: z.string().nonempty(),
                      password: z.string().nonempty()
                    });
                    return schema;
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              <DataCtxReader__>
                {$ctx => (
                  <React.Fragment>
                    <MultiFactorAuthModal
                      data-plasmic-name={"multiFactorAuthModal"}
                      data-plasmic-override={overrides.multiFactorAuthModal}
                      action={"login process"}
                      className={classNames(
                        "__wab_instance",
                        sty.multiFactorAuthModal
                      )}
                      cooldown={generateStateValueProp($state, [
                        "multiFactorAuthModal",
                        "cooldown"
                      ])}
                      factors={generateStateValueProp($state, [
                        "multiFactorAuthModal",
                        "factors"
                      ])}
                      isChallengeSubmitting={generateStateValueProp($state, [
                        "multiFactorAuthModal",
                        "isChallengeSubmitting"
                      ])}
                      methodSelected={generateStateValueProp($state, [
                        "multiFactorAuthModal",
                        "methodSelected"
                      ])}
                      onCooldownChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "multiFactorAuthModal",
                          "cooldown"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onFactorsChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "multiFactorAuthModal",
                          "factors"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onIsChallengeSubmittingChange={async (
                        ...eventArgs: any
                      ) => {
                        generateStateOnChangeProp($state, [
                          "multiFactorAuthModal",
                          "isChallengeSubmitting"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onMethodSelectedChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "multiFactorAuthModal",
                          "methodSelected"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onOpenChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "multiFactorAuthModal",
                          "open"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }

                        (async val => {
                          const $steps = {};

                          $steps["updateIsFormSubmitting"] =
                            !$state.multiFactorAuthModal.open &&
                            $state.isFormSubmitting
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: ["isFormSubmitting"]
                                    },
                                    operation: 0,
                                    value: false
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                          if (
                            $steps["updateIsFormSubmitting"] != null &&
                            typeof $steps["updateIsFormSubmitting"] ===
                              "object" &&
                            typeof $steps["updateIsFormSubmitting"].then ===
                              "function"
                          ) {
                            $steps["updateIsFormSubmitting"] =
                              await $steps["updateIsFormSubmitting"];
                          }
                        }).apply(null, eventArgs);
                      }}
                      onVerify={async (code, deliveryMethod) => {
                        const $steps = {};

                        $steps["runCode"] = true
                          ? (() => {
                              const actionArgs = {
                                customFunction: async () => {
                                  return (async () => {
                                    async function onVerify() {
                                      const onSubmit = async values => {
                                        const url = new URL(
                                          "/New/Login.ashx",
                                          window.location.href
                                        );
                                        const urlParams = new URLSearchParams(
                                          window.location.search
                                        );
                                        [
                                          "tempid",
                                          "autovoluntary",
                                          "qrid"
                                        ].forEach(param => {
                                          if (urlParams.has(param))
                                            url.searchParams.append(
                                              param,
                                              urlParams.get(param)
                                            );
                                        });
                                        if (code)
                                          url.searchParams.append(
                                            "authCode",
                                            code
                                          );
                                        if (deliveryMethod)
                                          url.searchParams.append(
                                            "deliveryMethod",
                                            deliveryMethod
                                          );
                                        const response = await fetch(url, {
                                          method: "POST",
                                          body: JSON.stringify({
                                            username: values.username,
                                            password: values.password
                                          }),
                                          headers: {
                                            "Content-type":
                                              "application/json; charset=UTF-8"
                                          }
                                        });
                                        if (response.ok) {
                                          const responseData =
                                            await response.json();
                                          if (responseData.title) {
                                            $ctx.toast.show({
                                              type: responseData?.factors
                                                ? "info"
                                                : "success",
                                              duration: 5000,
                                              title: responseData.title,
                                              description:
                                                responseData.description
                                            });
                                          }
                                          let redirectUrl =
                                            responseData.redirect;
                                          if (redirectUrl) {
                                            if (redirectUrl.startsWith("~")) {
                                              redirectUrl = redirectUrl.replace(
                                                /^~/,
                                                ""
                                              );
                                            }
                                            if (
                                              !redirectUrl.startsWith("http")
                                            ) {
                                              if (
                                                !redirectUrl.startsWith("/")
                                              ) {
                                                redirectUrl = `/${redirectUrl}`;
                                              }
                                              redirectUrl = `${window.location.origin}${redirectUrl}`;
                                            }
                                            window.location.href = redirectUrl;
                                          }
                                        } else {
                                          const errorData =
                                            await response.json();
                                          $state.multiFactorAuthModal.isChallengeSubmitting = false;
                                          $ctx.toast.show({
                                            id: 1,
                                            type: "error",
                                            duration: 5000,
                                            title: errorData.error.title,
                                            description:
                                              errorData.error.description
                                          });
                                        }
                                      };
                                      return $ctx.loginForm.handleSubmit(
                                        onSubmit
                                      )();
                                    }
                                    return onVerify();
                                  })();
                                }
                              };
                              return (({ customFunction }) => {
                                return customFunction();
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runCode"] != null &&
                          typeof $steps["runCode"] === "object" &&
                          typeof $steps["runCode"].then === "function"
                        ) {
                          $steps["runCode"] = await $steps["runCode"];
                        }
                      }}
                      open={generateStateValueProp($state, [
                        "multiFactorAuthModal",
                        "open"
                      ])}
                    />

                    <form
                      data-plasmic-name={"form"}
                      data-plasmic-override={overrides.form}
                      className={classNames(projectcss.all, sty.form)}
                      onSubmit={async event => {
                        const $steps = {};

                        $steps["runCode"] = true
                          ? (() => {
                              const actionArgs = {
                                customFunction: async () => {
                                  return (async () => {
                                    event.preventDefault();
                                    async function onFinish() {
                                      const onSubmit = async values => {
                                        try {
                                          $state.isFormSubmitting = true;
                                          const url = new URL(
                                            "/New/Login.ashx",
                                            window.location.href
                                          );
                                          const urlParams = new URLSearchParams(
                                            window.location.search
                                          );
                                          [
                                            "tempid",
                                            "autovoluntary",
                                            "qrid"
                                          ].forEach(param => {
                                            if (urlParams.has(param))
                                              url.searchParams.append(
                                                param,
                                                urlParams.get(param)
                                              );
                                          });
                                          const response = await fetch(url, {
                                            method: "POST",
                                            body: JSON.stringify({
                                              username: values.username,
                                              password: values.password,
                                              useDefaultFactor: false
                                            }),
                                            headers: {
                                              "Content-type":
                                                "application/json; charset=UTF-8"
                                            }
                                          });
                                          if (response.ok) {
                                            const responseData =
                                              await response.json();
                                            const factors =
                                              responseData.factors;
                                            if (factors) {
                                              $ctx.toast.show({
                                                id: 1,
                                                type: "info",
                                                duration: 5000,
                                                title: responseData.title,
                                                description:
                                                  responseData.description
                                              });
                                              const formattedFactors =
                                                factors.map(f => ({
                                                  value: f,
                                                  default: f === "Email"
                                                }));
                                              if (
                                                !formattedFactors.some(
                                                  f => f.default
                                                )
                                              ) {
                                                formattedFactors[0].default = true;
                                              }
                                              const defaultFactor =
                                                formattedFactors.find(
                                                  f => f.default
                                                );
                                              if (
                                                defaultFactor &&
                                                formattedFactors.length === 1
                                              ) {
                                                $state.multiFactorAuthModal.cooldown[
                                                  defaultFactor.value
                                                ] = 30;
                                              }
                                              $state.multiFactorAuthModal.factors =
                                                formattedFactors;
                                              $state.multiFactorAuthModal.methodSelected =
                                                formattedFactors.length === 1;
                                              $state.multiFactorAuthModal.open = true;
                                            } else {
                                              let redirectUrl =
                                                responseData.redirect;
                                              if (redirectUrl) {
                                                if (
                                                  redirectUrl.startsWith("~")
                                                ) {
                                                  redirectUrl =
                                                    redirectUrl.replace(
                                                      /^~/,
                                                      ""
                                                    );
                                                }
                                                if (
                                                  !redirectUrl.startsWith(
                                                    "http"
                                                  )
                                                ) {
                                                  if (
                                                    !redirectUrl.startsWith("/")
                                                  ) {
                                                    redirectUrl = `/${redirectUrl}`;
                                                  }
                                                  redirectUrl = `${window.location.origin}${redirectUrl}`;
                                                }
                                                window.location.href =
                                                  redirectUrl;
                                              }
                                            }
                                          } else {
                                            const errorData =
                                              await response.json();
                                            $ctx.toast.show({
                                              id: 1,
                                              type: "error",
                                              duration: 5000,
                                              title: errorData.error.title,
                                              description:
                                                errorData.error.description
                                            });
                                            $state.isFormSubmitting = false;
                                          }
                                        } catch (error) {
                                          $ctx.toast.show({
                                            id: 1,
                                            type: "error",
                                            duration: 5000,
                                            title: "Login Error",
                                            description:
                                              "Try again or contact us if issue persists"
                                          });
                                          $state.isFormSubmitting = false;
                                        }
                                      };
                                      const onError = () => {
                                        $ctx.toast.show({
                                          id: 1,
                                          type: "error",
                                          duration: 5000,
                                          title: "Incomplete Form",
                                          description:
                                            "Login or password fields cannot be empty"
                                        });
                                      };
                                      return $ctx.loginForm.handleSubmit(
                                        onSubmit,
                                        onError
                                      )();
                                    }
                                    return onFinish();
                                  })();
                                }
                              };
                              return (({ customFunction }) => {
                                return customFunction();
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runCode"] != null &&
                          typeof $steps["runCode"] === "object" &&
                          typeof $steps["runCode"].then === "function"
                        ) {
                          $steps["runCode"] = await $steps["runCode"];
                        }
                      }}
                    >
                      <FormControlProvider
                        data-plasmic-name={"usernameProvider"}
                        data-plasmic-override={overrides.usernameProvider}
                        className={classNames(
                          "__wab_instance",
                          sty.usernameProvider
                        )}
                        contextName={"usernameProvider"}
                        fieldName={"username"}
                        formControl={(() => {
                          try {
                            return $ctx.loginForm.control;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <DataCtxReader__>
                          {$ctx =>
                            (() => {
                              const child$Props = {
                                "aria-label": "Login",
                                autoFocus: false,
                                className: classNames(
                                  "__wab_instance",
                                  sty.usernameInput
                                ),
                                invalid: (() => {
                                  try {
                                    return $ctx.usernameProvider.fieldState
                                      .invalid;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })(),
                                name: "username",
                                onChange: async (...eventArgs: any) => {
                                  ((...eventArgs) => {
                                    generateStateOnChangeProp($state, [
                                      "usernameInput",
                                      "value"
                                    ])(
                                      (e => e.target?.value).apply(
                                        null,
                                        eventArgs
                                      )
                                    );
                                  }).apply(null, eventArgs);

                                  if (
                                    eventArgs.length > 1 &&
                                    eventArgs[1] &&
                                    eventArgs[1]._plasmic_state_init_
                                  ) {
                                    return;
                                  }

                                  (async event => {
                                    const $steps = {};

                                    $steps["runCode"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            customFunction: async () => {
                                              return $ctx.usernameProvider.field.onChange(
                                                event.target.value
                                              );
                                            }
                                          };
                                          return (({ customFunction }) => {
                                            return customFunction();
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runCode"] != null &&
                                      typeof $steps["runCode"] === "object" &&
                                      typeof $steps["runCode"].then ===
                                        "function"
                                    ) {
                                      $steps["runCode"] =
                                        await $steps["runCode"];
                                    }
                                  }).apply(null, eventArgs);
                                },
                                placeholder: "Username",
                                required: false,
                                size: "small",
                                startIcon: null,
                                type: "text",
                                value:
                                  generateStateValueProp($state, [
                                    "usernameInput",
                                    "value"
                                  ]) ?? ""
                              };

                              initializePlasmicStates(
                                $state,
                                [
                                  {
                                    name: "usernameInput.value",
                                    initFunc: ({
                                      $props,
                                      $state,
                                      $queries,
                                      $q
                                    }) =>
                                      (() => {
                                        try {
                                          return $ctx.usernameProvider.field
                                            .value;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return undefined;
                                          }
                                          throw e;
                                        }
                                      })()
                                  }
                                ],
                                []
                              );
                              return (
                                <TextInput
                                  data-plasmic-name={"usernameInput"}
                                  data-plasmic-override={
                                    overrides.usernameInput
                                  }
                                  {...child$Props}
                                />
                              );
                            })()
                          }
                        </DataCtxReader__>
                      </FormControlProvider>
                      <FormControlProvider
                        data-plasmic-name={"passwordProvider"}
                        data-plasmic-override={overrides.passwordProvider}
                        className={classNames(
                          "__wab_instance",
                          sty.passwordProvider
                        )}
                        contextName={"passwordProvider"}
                        fieldName={"password"}
                        formControl={(() => {
                          try {
                            return $ctx.loginForm.control;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <DataCtxReader__>
                          {$ctx =>
                            (() => {
                              const child$Props = {
                                "aria-label": "Password",
                                className: classNames(
                                  "__wab_instance",
                                  sty.passwordInput
                                ),
                                invalid: (() => {
                                  try {
                                    return $ctx.passwordProvider.fieldState
                                      .invalid;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })(),
                                name: "password",
                                onChange: async (...eventArgs: any) => {
                                  ((...eventArgs) => {
                                    generateStateOnChangeProp($state, [
                                      "passwordInput",
                                      "value"
                                    ])(
                                      (e => e.target?.value).apply(
                                        null,
                                        eventArgs
                                      )
                                    );
                                  }).apply(null, eventArgs);

                                  if (
                                    eventArgs.length > 1 &&
                                    eventArgs[1] &&
                                    eventArgs[1]._plasmic_state_init_
                                  ) {
                                    return;
                                  }

                                  (async event => {
                                    const $steps = {};

                                    $steps["runCode"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            customFunction: async () => {
                                              return $ctx.passwordProvider.field.onChange(
                                                event.target.value
                                              );
                                            }
                                          };
                                          return (({ customFunction }) => {
                                            return customFunction();
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runCode"] != null &&
                                      typeof $steps["runCode"] === "object" &&
                                      typeof $steps["runCode"].then ===
                                        "function"
                                    ) {
                                      $steps["runCode"] =
                                        await $steps["runCode"];
                                    }
                                  }).apply(null, eventArgs);
                                },
                                placeholder: "Password",
                                required: false,
                                showEndIcon: true,
                                size: "small",
                                startIcon: null,
                                type: "password",
                                value:
                                  generateStateValueProp($state, [
                                    "passwordInput",
                                    "value"
                                  ]) ?? ""
                              };

                              initializePlasmicStates(
                                $state,
                                [
                                  {
                                    name: "passwordInput.value",
                                    initFunc: ({
                                      $props,
                                      $state,
                                      $queries,
                                      $q
                                    }) =>
                                      (() => {
                                        try {
                                          return $ctx.passwordProvider.field
                                            .value;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return undefined;
                                          }
                                          throw e;
                                        }
                                      })()
                                  }
                                ],
                                []
                              );
                              return (
                                <TextInput
                                  data-plasmic-name={"passwordInput"}
                                  data-plasmic-override={
                                    overrides.passwordInput
                                  }
                                  {...child$Props}
                                />
                              );
                            })()
                          }
                        </DataCtxReader__>
                      </FormControlProvider>
                      <Button
                        data-plasmic-name={"logInButton"}
                        data-plasmic-override={overrides.logInButton}
                        aria-label={"Log in"}
                        className={classNames(
                          "__wab_instance",
                          sty.logInButton
                        )}
                        color={"sky"}
                        size={"small"}
                        submitsForm={true}
                      >
                        {(() => {
                          try {
                            return !$state.isFormSubmitting;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__e26Lb
                            )}
                          >
                            {"Log in"}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return $state.isFormSubmitting;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <SpinnerIcon
                            data-plasmic-name={"spinnerIcon"}
                            data-plasmic-override={overrides.spinnerIcon}
                            className={classNames(
                              "__wab_instance",
                              sty.spinnerIcon
                            )}
                          />
                        ) : null}
                      </Button>
                    </form>
                  </React.Fragment>
                )}
              </DataCtxReader__>
            </FormProvider>
            <PlasmicLink__
              data-plasmic-name={"link"}
              data-plasmic-override={overrides.link}
              aria-label={"Go to forgot username or password page"}
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link
              )}
              component={Link}
              href={`/forgot-password`}
              legacyBehavior={false}
              platform={"nextjs"}
              title={"Go to forgot username or password page"}
            >
              {"Forgot Username or Password?"}
            </PlasmicLink__>
          </div>
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  loginSection: [
    "loginSection",
    "login",
    "warning",
    "wrapper",
    "icon",
    "wrapper2",
    "img",
    "text",
    "wrapper4",
    "wrapper3",
    "title",
    "loginForm",
    "multiFactorAuthModal",
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon",
    "link"
  ],
  login: [
    "login",
    "warning",
    "wrapper",
    "icon",
    "wrapper2",
    "img",
    "text",
    "wrapper4",
    "wrapper3",
    "title",
    "loginForm",
    "multiFactorAuthModal",
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon",
    "link"
  ],
  warning: ["warning", "wrapper", "icon", "wrapper2", "img", "text"],
  wrapper: ["wrapper", "icon", "wrapper2", "img", "text"],
  icon: ["icon", "wrapper2", "img"],
  wrapper2: ["wrapper2", "img"],
  img: ["img"],
  text: ["text"],
  wrapper4: [
    "wrapper4",
    "wrapper3",
    "title",
    "loginForm",
    "multiFactorAuthModal",
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon",
    "link"
  ],
  wrapper3: [
    "wrapper3",
    "title",
    "loginForm",
    "multiFactorAuthModal",
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon",
    "link"
  ],
  title: ["title"],
  loginForm: [
    "loginForm",
    "multiFactorAuthModal",
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon"
  ],
  multiFactorAuthModal: ["multiFactorAuthModal"],
  form: [
    "form",
    "usernameProvider",
    "usernameInput",
    "passwordProvider",
    "passwordInput",
    "logInButton",
    "spinnerIcon"
  ],
  usernameProvider: ["usernameProvider", "usernameInput"],
  usernameInput: ["usernameInput"],
  passwordProvider: ["passwordProvider", "passwordInput"],
  passwordInput: ["passwordInput"],
  logInButton: ["logInButton", "spinnerIcon"],
  spinnerIcon: ["spinnerIcon"],
  link: ["link"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  loginSection: "section";
  login: "div";
  warning: "div";
  wrapper: "div";
  icon: "div";
  wrapper2: "div";
  img: typeof PlasmicImg__;
  text: "div";
  wrapper4: "div";
  wrapper3: "div";
  title: "label";
  loginForm: typeof FormProvider;
  multiFactorAuthModal: typeof MultiFactorAuthModal;
  form: "form";
  usernameProvider: typeof FormControlProvider;
  usernameInput: typeof TextInput;
  passwordProvider: typeof FormControlProvider;
  passwordInput: typeof TextInput;
  logInButton: typeof Button;
  spinnerIcon: typeof SpinnerIcon;
  link: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeLoginSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeLoginSection__VariantsArgs;
    args?: PlasmicHomeLoginSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeLoginSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeLoginSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeLoginSection__ArgProps,
          internalVariantPropNames: PlasmicHomeLoginSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeLoginSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "loginSection") {
    func.displayName = "PlasmicHomeLoginSection";
  } else {
    func.displayName = `PlasmicHomeLoginSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeLoginSection = Object.assign(
  // Top-level PlasmicHomeLoginSection renders the root element
  makeNodeComponent("loginSection"),
  {
    // Helper components rendering sub-elements
    login: makeNodeComponent("login"),
    warning: makeNodeComponent("warning"),
    wrapper: makeNodeComponent("wrapper"),
    icon: makeNodeComponent("icon"),
    wrapper2: makeNodeComponent("wrapper2"),
    img: makeNodeComponent("img"),
    text: makeNodeComponent("text"),
    wrapper4: makeNodeComponent("wrapper4"),
    wrapper3: makeNodeComponent("wrapper3"),
    title: makeNodeComponent("title"),
    loginForm: makeNodeComponent("loginForm"),
    multiFactorAuthModal: makeNodeComponent("multiFactorAuthModal"),
    form: makeNodeComponent("form"),
    usernameProvider: makeNodeComponent("usernameProvider"),
    usernameInput: makeNodeComponent("usernameInput"),
    passwordProvider: makeNodeComponent("passwordProvider"),
    passwordInput: makeNodeComponent("passwordInput"),
    logInButton: makeNodeComponent("logInButton"),
    spinnerIcon: makeNodeComponent("spinnerIcon"),
    link: makeNodeComponent("link"),

    // Metadata about props expected for PlasmicHomeLoginSection
    internalVariantProps: PlasmicHomeLoginSection__VariantProps,
    internalArgProps: PlasmicHomeLoginSection__ArgProps
  }
);

export default PlasmicHomeLoginSection;
/* prettier-ignore-end */
